import { CompanyInfo } from '../types/content';

export const companyInfo: CompanyInfo = {
  name: 'Technook Global',
  tagline: 'Software and System Development Solutions that Transform Life Easier',
  description: 'Technook is a technology hub dedicated to creating innovative software, digital solutions, and smart business systems that empower organizations to grow in the digital age.',
  email: 'info@technookglobal.com',
  phones: ['+639 56 928 4326', '+639 48 640 7680'],
  address: {
    building: 'Imperial Plaza',
    street: 'Diosdado Macapagal Blvd.',
    subdivision: 'Tambo',
    city: 'Parañaque City',
    region: 'Metro Manila',
    country: 'Philippines',
  },
  socials: {
    viber: '+639 56 928 4326',
    whatsapp: '+639 56 928 4326',
    linkedin: 'https://linkedin.com/company/technookglobal',
    facebook: 'https://facebook.com/technookglobal',
  },
};
